import repository from './repository'

const resource = 'people'

export default {
  index (params) {
    return repository.get(resource, { params })
  },
}
